/**
 * SecurityWatermark — semi-transparent diagonal repeating overlay
 * stamped with the viewing user's email + timestamp.
 *
 * Designed to deter screenshots / screen-recording of sensitive
 * customer / vendor / agent / distributor lists.
 */
import React, { useState, useEffect } from 'react';

const SecurityWatermark = ({ user, label = 'CONFIDENTIAL' }) => {
  const [now, setNow] = useState(() => new Date().toLocaleString('en-IN', { hour12: false }));

  useEffect(() => {
    const id = setInterval(() => setNow(new Date().toLocaleString('en-IN', { hour12: false })), 60000);
    return () => clearInterval(id);
  }, []);

  if (!user) return null;
  const email = user.email || user.username || 'user';

  // Build a repeating diagonal pattern using inline SVG -> data URL.
  // The pattern repeats both horizontally and vertically; each tile has the watermark text.
  const text = `${label} • ${email} • ${now}`;
  const svg = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns='http://www.w3.org/2000/svg' width='600' height='240' viewBox='0 0 600 240'>
  <g transform='rotate(-25 300 120)' opacity='0.10' fill='#0f172a' font-family='Arial, sans-serif' font-size='15' font-weight='600'>
    <text x='0'   y='40'>${text}</text>
    <text x='0'   y='120'>${text}</text>
    <text x='0'   y='200'>${text}</text>
  </g>
</svg>`;
  const url = `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;

  return (
    <div
      aria-hidden="true"
      data-testid="security-watermark"
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        backgroundImage: url,
        backgroundRepeat: 'repeat',
        zIndex: 9999,
        mixBlendMode: 'multiply',
      }}
    />
  );
};

export default SecurityWatermark;
